import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutDivisionCodeList extends Layout {
    layoutheaderDivisionCodeList: LayoutHeader;
    sourceDivisionLookup: DataSource;
    tableDivisionCodes: Table;
}
